///////////////////////////////////////////////////////////////////////// LEVELS ARR
export const GET_LEVELS_ARR = "GET_LEVELS_ARR";

export const SET_LEVELS_ARR = "SET_LEVELS_ARR";

///////////////////////////////////////////////////////////////////////// SCORE POINTS
export const SET_SCORE_POINTS = "SET_SCORE_POINTS";

export const GET_SCORE_POINTS = "GET_SCORE_POINTS";

export const GET_SCORE_POINTS_TABLE = "GET_SCORE_POINTS_TABLE";

///////////////////////////////////////////////////////////////////////// RESET DATA
export const RESET_DATA = "RESET_DATA";

///////////////////////////////////////////////////////////////////////// SECRET LEVEL
export const SET_SECRET_LEVEL = "SET_SECRET_LEVEL"
